import { UseFormReturn } from "react-hook-form";

import Grid from "@mui/material/Grid";

import {
  FormDateField,
  FormTextField,
  FormEmailAutocorrect,
} from "@covertree/ui";

import FormPhoneField from "@covertree/ui/forms/FormPhoneField";
import {
  OccupationTypeSelect,
  NumberOfVehiclesInput,
  PersonalDetailsWithExtraQuestionsForm,
} from "@covertree/new-business-forms";
import { useHideEmailSuggestionOnScroll } from "@hooks/scroll/useHideEmailSuggestionOnScroll";

interface Props {
  form: UseFormReturn<PersonalDetailsWithExtraQuestionsForm>;
}

export function PolicyholderPersonFormFields({ form }: Props) {
  const { hideSuggestion } = useHideEmailSuggestionOnScroll("email-field");

  const { control, setValue, watch } = form;

  const noEmail = watch("noEmail");

  return (
    <>
      <Grid item md={6}>
        <FormTextField
          id="first-name"
          dataTestId="first-name-input"
          name="firstName"
          label="First name"
          control={control}
        />
      </Grid>
      <Grid item md={6}>
        <FormTextField
          id="middle-name"
          dataTestId="middle-name-input"
          name="middleName"
          label="Middle name"
          control={control}
          optional
        />
      </Grid>
      <Grid item md={6}>
        <FormTextField
          id="last-name"
          dataTestId="last-name-input"
          name="lastName"
          label="Last name"
          control={control}
        />
      </Grid>
      <Grid item md={6}>
        <FormDateField
          id="date-of-birth"
          dataTestId="birth-date"
          name="insuredDateOfBirth"
          label="Date of birth"
          control={control}
        />
      </Grid>
      <Grid item xs={6}>
        <FormPhoneField
          id="phone-number"
          dataTestId="phone-number-input"
          name="primaryContactNumber"
          label="Phone number"
          control={control}
        />
      </Grid>

      <Grid item xs={6}>
        <FormPhoneField
          id="second-phone-number"
          dataTestId="second-phone-number-input"
          name="secondaryContactNumber"
          label="Secondary phone number"
          control={control}
          optional
        />
      </Grid>
      <Grid item xs={12}>
        <FormEmailAutocorrect
          id="email-field"
          dataTestId="email-input"
          name="emailAddress"
          label="Email"
          tooltip="Client's email for document delivery"
          control={control}
          setValue={setValue}
          isEnabled={true}
          hideSuggestion={hideSuggestion}
          disabled={noEmail}
        />
      </Grid>
      <Grid item xs={6}>
        <OccupationTypeSelect />
      </Grid>
      <Grid item xs={6}>
        <NumberOfVehiclesInput />
      </Grid>
    </>
  );
}
